<template>
  <div class="doc-container">
    <div class="doc-tab">
      <!-- 选择模块 -->
      <div class="choose-box flex-between">
        <!-- 选择语言 -->
        <div class="flex-align-center">
          <language-group
            @change="changeLanguage"
            ref="languageRef"
            type="img"
          ></language-group>
        </div>
        <div class="flex-align-center">
          <div
            class="flex-center"
            v-if="
              !flag && settingDetail.native_engine_recommend_hidden !== 'true'
            "
          >
            <div
              class="flex-center margin-r-10"
              v-if="recommendMtList.length === 0"
            >
              <img
                src="../../../images/ai-img.png"
                alt=""
                width="16"
                height="16"
              />
              <span class="color-666 font-size-14 padding-l-6">
                AI将为您智能推荐引擎
              </span>
            </div>
            <div class="flex-center margin-r-10" v-else>
              <img
                src="../../../images/ai-img.png"
                alt=""
                width="16"
                height="16"
              />
              <span class="color-666 font-size-14 padding-l-6 padding-r-10">
                AI推荐引擎：
              </span>
              <div class="recommend-res flex-align-center">
                <div
                  v-for="(item, key) in recommendMtList"
                  :key="key"
                  :class="[
                    'mt-item',
                    'cursor-pointer',
                    twinslatorId == item.twinslatorId ? 'mt-item-active' : '',
                  ]"
                  @click="chooseMt(item, 'recommend')"
                >
                  <div>
                    <div class="flex-align-center">
                      <svg aria-hidden="true" class="icon">
                        <use :xlink:href="'#' + item.iconName"></use>
                      </svg>
                      <span
                        class="padding-l-8 height-16"
                        :title="item.twinslatorName"
                      >
                        {{ item.twinslatorName }}
                      </span>
                    </div>
                    <div class="mt-price">{{ item.price }}译力</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-dropdown
            :trigger="['click']"
            placement="bottomRight"
            v-model:visible="visible"
          >
            <div
              class="choose-mt-box cursor-pointer flex-center"
              @click.prevent
              v-if="chooseTwinslatorObj?.twinslatorId"
            >
              <div>
                <div class="flex-center">
                  <svg aria-hidden="true" class="icon">
                    <use :xlink:href="'#' + chooseTwinslatorObj.iconName"></use>
                  </svg>
                  <span
                    style="height: 16px"
                    class="padding-l-8 padding-r-5 font-size-12"
                    :title="chooseTwinslatorObj.twinslatorName"
                  >
                    {{ chooseTwinslatorObj.twinslatorName }}
                  </span>
                </div>
                <div class="mt-price">
                  {{ chooseTwinslatorObj.price }}译力/千字
                </div>
              </div>
              <DownOutlined class="font-size-12 padding-l-4" />
            </div>

            <div
              class="choose-mt-default-box flex-center cursor-pointer"
              @click.prevent
              v-else
            >
              <div>
                <div class="text-center">
                  {{ recommendMtList.length > 0 ? '更多' : '全部引擎' }}
                  <DownOutlined class="font-size-12 padding-l-5" />
                </div>
              </div>
            </div>
            <template #overlay>
              <div class="all-mt-box" @click.prevent>
                <div class="mt-tabs display-flex">
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 1 && 'mt-tab-active'"
                    @click="mtType = 1"
                  >
                    垂直领域
                  </div>
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 2 && 'mt-tab-active'"
                    @click="mtType = 2"
                  >
                    通用领域
                  </div>
                  <div
                    class="mt-tab flex-align-center margin-r-30"
                    :class="mtType == 5 && 'mt-tab-active'"
                    @click="mtType = 5"
                  >
                    大模型
                  </div>
                  <div
                    v-if="myMt.length > 0"
                    class="mt-tab flex-align-center"
                    :class="mtType == 3 && 'mt-tab-active'"
                    @click="mtType = 3"
                  >
                    {{ enterpriseGlobalId == 'personal' ? '我的' : '企业' }}
                  </div>
                </div>
                <div class="mt-transn mt-common" v-if="mtType == 1">
                  <div class="display-flex">
                    <div
                      style="
                        width: 3px;
                        height: 12px;
                        background: var(--primary-color);
                        border-radius: 2px;
                        margin-top: 4px;
                      "
                    ></div>
                    <div
                      class="padding-l-10 padding-r-12 color-666 font-size-12"
                      style="line-height: 22px"
                    >
                      平台自研
                    </div>
                    <div class="display-flex flex-wrap flex-1">
                      <div
                        v-for="(item, key) in companyMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-15"
                        @click="chooseMt(item, 'all')"
                        v-if="companyMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                          <EngineTag :item="item"></EngineTag>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                          :title="item.twinslatorName"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                        <!-- 角标 -->
                        <div class="badge-box" v-if="item.iconType">
                          <img
                            src="../../../images/hot-mt-img.png"
                            v-if="item.iconType == 'HOT'"
                            alt=""
                          />
                          <img
                            src="../../../images/new-mt-img.png"
                            v-if="item.iconType == 'NEWEST'"
                            alt=""
                          />
                        </div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                  <div class="display-flex margin-t-12">
                    <div
                      style="
                        width: 3px;
                        height: 12px;
                        background: #00befa;
                        border-radius: 2px;
                        margin-top: 2px;
                      "
                    ></div>
                    <div
                      class="padding-l-10 padding-r-12 color-666 font-size-12"
                    >
                      联合共建
                    </div>
                    <div class="display-flex flex-wrap flex-1">
                      <div
                        v-for="(item, key) in userMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-15"
                        @click="chooseMt(item, 'all')"
                        v-if="userMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                          <EngineTag :item="item"></EngineTag>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                          :title="item.twinslatorName"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 2">
                  <div class="display-flex flex-wrap">
                    <div
                      v-for="(item, key) in generalMt"
                      :key="key"
                      class="mt-choose-item margin-b-12 margin-r-12"
                      @click="chooseMt(item, 'all')"
                      v-if="generalMt.length > 0"
                    >
                      <div class="flex-center mt-icon-box">
                        <EngineTag :item="item"></EngineTag>
                        <svg aria-hidden="true" class="icon">
                          <use :xlink:href="'#' + item.iconName"></use>
                        </svg>
                      </div>
                      <div
                        class="text-center color-333 font-size-12 padding-t-6 white-1"
                      >
                        {{ item.twinslatorName }}
                      </div>
                      <div class="mt-price">{{ item.price }}译力/千字</div>
                    </div>
                    <div v-else class="padding-l-20 font-size-12 color-999">
                      暂无数据
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 3">
                  <div class="display-flex flex-wrap">
                    <div
                      v-for="(item, key) in myMt"
                      :key="key"
                      class="mt-choose-item margin-b-12 margin-r-12"
                      @click="chooseMt(item, 'all')"
                      v-if="myMt.length > 0"
                    >
                      <div class="flex-center mt-icon-box">
                        <EngineTag :item="item"></EngineTag>
                        <svg aria-hidden="true" class="icon">
                          <use :xlink:href="'#' + item.iconName"></use>
                        </svg>
                      </div>
                      <div
                        class="text-center color-333 font-size-12 padding-t-6 white-1"
                      >
                        {{ item.twinslatorName }}
                      </div>
                      <div class="mt-price">{{ item.price }}译力/千字</div>
                    </div>
                    <div v-else class="padding-l-20 font-size-12 color-999">
                      暂无数据
                    </div>
                  </div>
                </div>
                <div class="mt-general mt-common" v-else-if="mtType == 5">
                  <aiMtView
                    v-model:parentVisible="visible"
                    :list="aiMt"
                    @onChange="chooseMt"
                    @get-list="getAllMtList"
                  />
                </div>
              </div>
            </template>
          </a-dropdown>
        </div>
      </div>
      <!-- 翻译模块 -->
      <div class="translate-box">
        <a-upload-dragger
          accept=".jpg,.JPG,.jpeg,.JPEG,.png,.PNG"
          name="file"
          :showUploadList="false"
          :disabled="isPre"
          :customRequest="customRequest"
          v-if="!textFileId"
        >
          <!-- 上传中 -->
          <div v-if="spinLoading">
            <div
              class="color-333 font-size-18 font-weight-400 margin-t-12 margin-b-10"
            >
              拖拽图片到此进行翻译
            </div>
            <p class="color-999 font-size-14 margin-b-20">图片不超过10M</p>
            <a-spin :tip="!files.fileId ? '上传中...' : '上传中...'" />
          </div>
          <!-- 未上传 -->
          <div v-else>
            <div class="margin-t-6 display-flex align-center justify-center">
              <div>
                <img src="./images/translation/img-icon.png" width="128" />
              </div>
            </div>
            <div class="color-333 font-size-18 font-weight-400 margin-t-12">
              拖拽图片到此进行翻译
            </div>
            <p class="color-999 font-size-14 margin-b-20">图片不超过10M</p>
            <div class="btn-box display-flex align-center justify-center">
              <a-button
                type="primary"
                size="large"
                class="trans-btn margin-b-30"
                @click="uploadClick($event)"
              >
                上传图片
              </a-button>
            </div>

            <div class="display-flex">
              <div class="term-corpus-box flex-center">
                <div class="flex-center" @click.stop.native="() => {}">
                  <div class="flex-center">
                    <a-checkbox v-model:checked="checked" class="font-size-14">
                      术语
                    </a-checkbox>
                    <div
                      class="choose-term flex-align-center"
                      v-if="checked"
                      @click.stop="showTermModal"
                    >
                      <div
                        class="color-bbb font-weight-400 font-size-14"
                        v-if="!defaultTerm?.library_name"
                      >
                        请选择术语库
                      </div>
                      <div
                        v-else
                        style="max-width: 150px"
                        class="white-1"
                        :title="defaultTerm?.library_name || ''"
                      >
                        {{ defaultTerm?.library_name }}
                      </div>
                      <DownOutlined class="down-icon" />
                    </div>
                  </div>
                  <div class="flex-center">
                    <a-checkbox
                      v-model:checked="corpusChecked"
                      class="font-size-14"
                    >
                      语料
                    </a-checkbox>
                    <div
                      class="choose-term flex-align-center"
                      v-if="corpusChecked"
                      @click.stop="showCorpusModal"
                    >
                      <div
                        class="color-bbb font-weight-400 font-size-14"
                        v-if="!defaultCorpus?.library_name"
                      >
                        请选择语料库
                      </div>
                      <div
                        v-else
                        style="max-width: 150px"
                        class="white-1"
                        :title="defaultCorpus?.library_name || ''"
                      >
                        {{ defaultCorpus?.library_name }}
                      </div>
                      <DownOutlined class="down-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-upload-dragger>
        <!-- 上传完成 -->
        <div v-else class="success-box">
          <div class="file-type-box">
            <fileIcon size="48" :name="files.fileName"></fileIcon>
          </div>
          <div class="file-name padding-tb-20">
            {{ files.fileName }}&nbsp;&nbsp;&nbsp;&nbsp;
            <svg
              aria-hidden="true"
              class="icon"
              v-if="fileRes.progressStatus == 1"
              style="cursor: not-allowed; user-select: none"
            >
              <use xlink:href="#icon-qingchu"></use>
            </svg>
            <a-tooltip v-else>
              <template #title>删除</template>

              <svg aria-hidden="true" class="icon" @click.stop="removeFile">
                <use xlink:href="#icon-qingchu"></use>
              </svg>
            </a-tooltip>
            <div class="text-center color-999 padding-t-10">
              {{ files.fileSize && (files.fileSize / 1024 / 1024).toFixed(2) }}M
            </div>
          </div>
          <div
            class="btn-box display-flex align-center justify-center"
            v-if="!fileRes.progress"
          >
            <a-button
              type="primary"
              size="large"
              class="trans-btn"
              :loading="loading"
              @click="startFunc"
            >
              立即翻译
            </a-button>
          </div>
          <div v-else class="text-center">
            <div class="text-center font-size-24 color-7a59ff font-weight-600">
              {{ fileRes.progress }}%
            </div>
            <a-progress
              :stroke-color="{
                from: 'var(--primary-color)',
                to: '#7DE0FF',
              }"
              :percent="fileRes.progress"
              status="active"
              class="progress-box"
            />
            <div class="color-7a59ff text-center padding-t-2">
              图片翻译中，您可在右上角查看翻译记录
            </div>
          </div>
          <div
            class="term-corpus-box flex-center"
            v-if="sourceLangId && targetLangId && !fileRes.progress"
            @click.stop.native="() => {}"
          >
            <div
              v-if="files.extension === 'pdf' || files.extension === 'PDF'"
              class="flex-center margin-r-20"
            >
              <span class="font-size-14" style="flex-shrink: 0">
                解析方式：
              </span>
              <a-select
                v-model:value="parseMode"
                class="select-box"
                style="width: 180px"
              >
                <!--//暂时屏蔽-->
                <!--                <a-select-option :value="1">文字多，转word解析</a-select-option>-->
                <a-select-option :value="2">
                  图片格式多，pdf解析
                </a-select-option>
              </a-select>
            </div>

            <div class="flex-center">
              <a-checkbox v-model:checked="checked" class="font-size-14">
                术语
              </a-checkbox>
              <div
                class="choose-term flex-align-center"
                v-if="checked"
                @click="showTermModal"
              >
                <div
                  class="color-bbb font-weight-400 font-size-14"
                  v-if="!defaultTerm?.library_name"
                >
                  请选择术语库
                </div>
                <div
                  v-else
                  style="max-width: 150px"
                  class="white-1"
                  :title="defaultTerm?.library_name || ''"
                >
                  {{ defaultTerm?.library_name }}
                </div>
                <DownOutlined class="down-icon" />
              </div>
            </div>

            <div class="flex-center">
              <a-checkbox v-model:checked="corpusChecked" class="font-size-14">
                语料
              </a-checkbox>
              <div
                class="choose-term flex-align-center"
                v-if="corpusChecked"
                @click="showCorpusModal"
              >
                <div
                  class="color-bbb font-weight-400 font-size-14"
                  v-if="!defaultCorpus?.library_name"
                >
                  请选择术语库
                </div>
                <div
                  v-else
                  style="max-width: 150px"
                  class="white-1"
                  :title="defaultCorpus?.library_name || ''"
                >
                  {{ defaultCorpus?.library_name }}
                </div>
                <DownOutlined class="down-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 翻译列表 -->
    <DocTranslationList ref="translationListRef" />

    <!-- 术语列表弹窗 -->
    <TermModal
      v-model:termVisible="termVisible"
      :termData="termData"
      :libId="defaultTerm.library_id"
      @updateDefaultTerm="updateDefaultTerm"
    />

    <calculateTextModal
      ref="calculateTextRef"
      :mtDetail="chooseTwinslatorObj"
    ></calculateTextModal>

    <!--语料库弹窗-->
    <CorpusModal
      v-model:corpusVisible="corpusVisible"
      :corpusData="corpusData"
      :libId="defaultCorpus.library_id"
      @updateDefaultCorpus="updateDefaultCorpus"
    ></CorpusModal>
  </div>
</template>

<script>
  import {
    ref,
    reactive,
    toRefs,
    onMounted,
    watch,
    onUnmounted,
    computed,
    onBeforeUnmount,
  } from 'vue'
  import { UploadOutlined, DownOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  import {
    getNewUploadToken,
    uploadFile,
    getAllTwinslators,
    getDocCharCount,
    getDocCharCountByCache,
    queryDocMtCostByCharCount,
    createDocMtTask,
    getUploadTokenNew,
    uploadFileNew,
    enginesList,
    getRecommendTwinslators,
    getDocMtLibList,
    refreshDocTwinslatorMtStatus,
    getDocTranslateLib,
    getTranslateUrl,
  } from '@/http/api'
  import LanguageGroup from '../components/Language/LanguageGroup.vue'
  import MtPrice from './MtModal/Price.vue'
  import MtSuccess from './MtModal/Success.vue'
  import AddTerms from '../components/AddTerms.vue'
  import TermModal from './MtModal/TermModal.vue'
  import CorpusModal from './MtModal/CorpusModal.vue'
  import FileIcon from '@/views/experience/docTranslation/module/fileIcon.vue'
  import calculateTextModal from '@/components/Modal/calculateTextModal.vue'
  import aiMtView from '@/components/aiMt/index.vue'
  import DocTranslationList from '@/views/experience/docTranslationList/index.vue'

  export default {
    components: {
      calculateTextModal,
      FileIcon,
      CorpusModal,
      UploadOutlined,
      DownOutlined,
      LanguageGroup,
      MtPrice,
      MtSuccess,
      AddTerms,
      TermModal,
      aiMtView,
      DocTranslationList,
    },
    setup() {
      const loading = ref(false)
      const isPre = ref(false)
      const spinLoading = ref(false)
      const loadingOpacity = ref(false)
      const files = ref({})

      const translationListRef = ref(null)

      // const successVisible = ref(false)
      // const priceRef = ref(null);
      const calculateTextRef = ref(null)
      const store = useStore()
      const uploadSize = computed(() => {
        return (
          store.state.comm.userLevel?.privilege?.file_upload_single_size || 20
        )
      })

      const permission = computed(
        () => store.state.comm.enterpriseGlobalObj?.permission || []
      )

      const router = useRouter()
      const route = useRoute()
      const query = route.query
      const flag = query?.type && query?.type == 'imgTranslate'

      const enterpriseGlobalId = computed(
        () => store.state.comm.enterpriseGlobalId
      )
      const settingDetail = computed(() => store.state.comm.settingDetail)

      let refreshTimer = null

      const state = reactive({
        allMtList: [],
        twinslatorName: '',
        twinslatorId: (flag && query?.twinslatorId) || null,
        docUrl: '',
        detailData: {},
        sourceLangId: (flag && query?.sourceLangId) || undefined,
        targetLangId: (flag && query?.targetLangId) || undefined,
        industryId: '',
        wordCount: '',
        recommendMtList: [],
        mtList: [], // 所有引擎
        companyMt: [], // 公司自研
        userMt: [], // 用户共建
        generalMt: [], // 通用引擎
        myMt: [], // 我的引擎
        aiMt: [], // 大模型
        chooseTwinslatorObj: {},
        visible: false,
        textFileId: '',
        mtType: 1, // 1 垂直领域， 2 通用领域
        checked: true, //应用术语库选择
        corpusChecked: true, //应用语料库选择
        isShow: false,
        termData: [], //术语库数据
        corpusData: [], //语料库数据
        defaultTerm: {},
        defaultCorpus: {},
        termVisible: false,
        corpusVisible: false,
        fileRes: {},
        parseMode: 2,
      })

      const languageRef = ref(null)

      const _dbFile = sessionStorage.getItem('db_file')
      const dbFile = _dbFile ? JSON.parse(_dbFile) : ''
      if (dbFile) {
        files.value.fileName = dbFile.docName
        files.value.fileSize = dbFile.docSize
        files.value.fileId = dbFile.fileId
        state.docUrl = dbFile.docUrl
        state.textFileId = dbFile.textFileId
      }

      // 过滤 channel&invitePeople 字段
      const filterFunc = () => {
        let _url = ''
        if (route.path == '/detail') {
          const _query = route.query
          if (_query.channel) {
            delete _query.channel
          }
          if (_query.invitePeople) {
            delete _query.invitePeople
          }
          _url = `${window.location.origin + window.location.pathname}?id=${
            _query.id
          }&type=${_query.type}`
        } else {
          _url = location.href
        }
        return _url
      }

      // 登录
      const login = () => {
        const shareId = localStorage.shareId || ''
        const channel = localStorage.channel || ''
        const _url = filterFunc()
        let url = shareId
          ? encodeURIComponent(
              _url +
                `&channel=${channel}&type=docTranslate&invitePeople=` +
                shareId
            )
          : channel
            ? encodeURIComponent(
                _url +
                  (_url.includes('?') ? '&' : '?') +
                  `channel=${channel}&type=docTranslate`
              )
            : encodeURIComponent(_url + '?type=docTranslate')
        window.location.href = window.env.login + '/cas/login?service=' + url
        window.localStorage.removeItem('channel')
        window.localStorage.removeItem('shareId')
      }

      // 立即翻译
      const startFunc = async () => {
        if (!state.sourceLangId) {
          message.warning('请选择源语种')
          return
        }
        if (!state.targetLangId) {
          message.warning('请选择目标语种')
          return
        }
        if (!state.twinslatorId) {
          message.warning('请选择机翻引擎')
          return
        }
        if (!state.docUrl) {
          message.warning('请上传图片')
          return
        }

        loading.value = true
        try {
          const res = await queryDocMtCostByCharCount({
            docUrl: state.docUrl,
            twinslatorId: state.twinslatorId,
            fileId: files.value.fileId,
            libraryId: state.checked ? state.defaultTerm?.library_id : '',
          })
          if (res) {
            const _data = res.data.data
            // state.pricevisible = true
            state.detailData = _data
            // if (state.wordCount) {
            //   state.detailData.wordCount = state.wordCount
            // }
            state.detailData.wordCount = _data.etokenWordCount
            //初始化扣费
            calculateTextRef.value.init(
              state.detailData,
              () => {
                confirmOrder()
              },
              () => {
                loading.value = false
              }
            )
          } else {
            loading.value = false
          }
        } catch (error) {
          loading.value = false
        }
      }

      // 上传
      const customRequest = async ({ file }) => {
        if (!permission.value.includes('tc.twinsmt.use')) {
          message.error('您在企业内暂无图片快翻权限，可联系管理员调整权限')
          return
        }

        const acceptstr = `.jpg,.JPG,.jpeg,.JPEG,.png,.PNG`
        const accept = acceptstr.split(',')
        const extension = file.name.substring(
          file.name.lastIndexOf('.') + 1,
          file.name.length
        )
        if (!accept.includes(`.${extension}`)) {
          message.error('不支持的图片格式')
          return
        }

        if (file.size > 10 * 1024 * 1024) {
          message.warning(`单个图片大小不能超过10M`)
          return
        }

        if (file.size === 0) {
          message.warning('当前图片为空图片，请重新上传')
          return
        }

        spinLoading.value = true

        const { data: _data } = await getUploadTokenNew({
          use: 'free_file_mt',
          fileName: file.name,
          fileSize: file.size,
        })

        const _headers = _data.additionalHeader

        uploadFileNew(_data.uploadUrl, _headers, file)
          .then(() => {
            files.value = _data
            files.value.fileName = file.name
            files.value.fileSize = file.size
            files.value.extension = extension

            let params = {
              fileId: files.value.fileId,
              fileName: file.name,
              fileSize: file.size,
              sourceLangId: state.sourceLangId,
              targetLangId: state.targetLangId,
            }
            getDocCharCount(params)
              .then((res) => {
                const _data = res.data.data
                state.docUrl = _data.docUrl
                getDocCharCountByCacheFunc(files.value.fileId)
              })
              .catch((err) => {
                spinLoading.value = false
              })
          })
          .catch((err) => {
            spinLoading.value = false
            message.error('上传失败')
          })
      }

      // 清除
      const removeFile = () => {
        state.textFileId = ''
        files.value = {}
        loading.value = false
        isPre.value = false
        loadingOpacity.value = false
        state.docUrl = ''
        spinLoading.value = false
        state.chooseTwinslatorObj = {}
        state.twinslatorId = ''
        state.recommendMtList = []
        state.fileRes = {}
        sessionStorage.removeItem('db_file')
      }

      //
      const uploadClick = (e) => {
        if (!permission.value.includes('tc.twinsmt.use')) {
          message.error('您在企业内暂无图片快翻权限，可联系管理员调整权限')
          e.stopPropagation()
          e.preventDefault()
          return
        }
        if (!state.sourceLangId || !state.targetLangId) {
          message.warning('请先选择源语种和目标语种')
          e.stopPropagation()
          e.preventDefault()
          return
        }
      }

      // 轮询当前进度
      const refreshFunc = async (docIds) => {
        try {
          const res = await refreshDocTwinslatorMtStatus({ docIds })
          const list = res.data.data.list
          const data = list.length > 0 && list[0]
          state.fileRes = data

          if (data.progressStatus == 2) {
            loading.value = false
            message.error('翻译失败')
            removeFile()
            return
          }
          if (data.progressStatus == 4) {
            loading.value = false
            message.error('解析失败')
            removeFile()
            return
          }
          if (data.progressStatus == 3) {
            loading.value = false
            message.success('解析成功')
            router.push({
              path: '/experiencePreview',
              query: {
                taskId: data.taskId,
              },
            })
            return
          }
          refreshTimer = setTimeout(() => {
            refreshFunc(docIds)
          }, 2000)
        } catch (error) {
          loading.value = false
        }
      }

      // 确认下单
      const confirmOrder = () => {
        let params = {
          fileHash: files.value.hash,
          fileId: files.value.fileId,
          fileName: files.value.fileName,
          fileSize: files.value.size,
          fileType: files.value.fileType,
          industryId: state.industryId,
          sourceLangId: state.sourceLangId || '1',
          targetLangId: state.targetLangId || '2',
          mtId: state.twinslatorId,
          twinslatorId: state.twinslatorId,
          taskClassify: 10,
          termLibraryId: state.checked
            ? state.defaultTerm?.library_id
            : undefined,
          getStyle: 1,
          corpusLibraryId: state.corpusChecked
            ? state.defaultCorpus?.library_id
            : undefined,
        }
        // console.log(files.value)
        if (
          files.value.fileName.split('.').pop() === 'pdf' ||
          files.value.fileName.split('.').pop() === 'PDF'
        ) {
          params.parseMode = state.parseMode
        }
        createDocMtTask(params)
          .then((res) => {
            translationListRef?.value?.getList()
            removeFile()
            // const data = res.data.data
            // refreshFunc(data.docId)
            // priceRef.value.loading = false
          })
          .catch(() => {
            // priceRef.value.loading = false
            loading.value = false
          })
      }

      // 获取推荐引擎列表
      const getRecommendTwList = () => {
        if (!state.sourceLangId || !state.targetLangId) return
        if (settingDetail.value.native_engine_recommend_hidden === 'true')
          return
        getRecommendTwinslators({
          sourceLangId: state.sourceLangId,
          targetLangId: state.targetLangId,
          textFileId: state.textFileId,
        })
          .then((res) => {
            const data = res.data.data
            state.recommendMtList = data.list || []
          })
          .catch(() => {
            state.recommendMtList = []
          })
      }

      // 自动检测源语种
      const getDocCharCountByCacheFunc = async (fileId, sourceLangId) => {
        try {
          const res = await getDocCharCountByCache({
            fileId,
            sourceLangId,
          })
          const _data = res.data.data
          if (_data) {
            if (_data.errno && _data.errno == 1) {
              message.error(_data.message || '图片解析失败')
              removeFile()
              return
            }

            // state.sourceLangId = _data.sourceLangId
            // languageRef.value.srcLanguage = state.sourceLangId
            // if (state.sourceLangId == 1) {
            //   state.targetLangId = 2
            //   languageRef.value.tarLanguage = 2
            // } else {
            //   state.targetLangId = 1
            //   languageRef.value.tarLanguage = 1
            // }
            if (_data.textFileId) {
              state.wordCount = _data.wordCount
              state.textFileId = _data.textFileId
              state.spinLoading = false
              loading.value = false
              getRecommendTwList(_data.textFileId)
              getAllMtList()
              return
            }
          }
          setTimeout(() => {
            getDocCharCountByCacheFunc(fileId, sourceLangId)
          }, 1000)
        } catch (error) {
          state.spinLoading = false
        }
      }

      // 更改语言
      const changeLanguage = (v) => {
        if (
          state.sourceLangId &&
          state.sourceLangId != v.srcLanguage &&
          files.value.fileId
        ) {
          let params = {
            fileId: files.value.fileId,
            fileName: files.value.fileName,
            fileSize: files.value.fileSize,
            sourceLangId: v.srcLanguage,
          }
          spinLoading.value = true
          loading.value = true
          getDocCharCount(params)
            .then((res) => {
              const _data = res.data.data
              state.docUrl = _data.docUrl
              getDocCharCountByCacheFunc(files.value.fileId, v.srcLanguage)
            })
            .catch((err) => {
              spinLoading.value = false
            })
        }
        state.targetLangId = v.tarLanguage
        state.sourceLangId = v.srcLanguage
        state.twinslatorId = null
        state.chooseTwinslatorObj = {}

        getRecommendTwList()
        getAllMtList()
      }

      // 获取全部引擎列表
      const getAllMtList = () => {
        return enginesList({
          sourceLangId: state.sourceLangId,
          targetLangId: state.targetLangId,
          twinslatorId: state.twinslatorId || undefined,
        }).then((res) => {
          const data = res.data.data
          state.mtList = data.list || []
          state.companyMt = state.mtList.filter((item) => item.type == 1)
          state.userMt = state.mtList.filter((item) => item.type == 2)
          state.generalMt = state.mtList.filter((item) => item.type == 3)
          state.myMt = state.mtList.filter((item) => item.type == 4)
          state.aiMt = state.mtList.filter((item) => item.type == 5)
          if (state.companyMt.length === 0 && state.userMt.length === 0) {
            state.mtType = 2
          }
          if (flag && state.twinslatorId) {
            const arr = state.mtList.filter(
              (item) => item.twinslatorId == state.twinslatorId
            )
            if (arr.length > 0) {
              state.chooseTwinslatorObj = arr[0]
            } else {
              state.chooseTwinslatorObj = {}
              state.twinslatorId = ''
            }
          }
        })
      }

      // 点击引擎
      const chooseMt = (item, type) => {
        if (type == 'all' && !item.support) return

        if (loading.value) {
          message.warning('上传图片中不可切换引擎')
          return
        }

        if (type == 'all') {
          state.chooseTwinslatorObj = item
        } else {
          state.chooseTwinslatorObj = {}
        }
        state.visible = false
        state.twinslatorId = item.twinslatorId
      }

      // 获取库列表
      const getDocMtLibListFunc = () => {
        getDocTranslateLib({
          libType: 1,
          sourceLanguageId: state.sourceLangId || 1,
          targetLanguageId: state.targetLangId,
          langReverse: true,
          includeShare: false,
          includeCollect: false,
        }).then((res) => {
          let myList = res.data.data.myLibs || []
          let eList = res.data.data.enterpriseLibs || []
          myList.forEach((item) => {
            item.libType = 1
          })
          eList.forEach((item) => {
            item.libType = 2
          })
          const list = [...myList, ...eList]
          state.termData = list
        })
      }

      //获取语料库列表
      const getDocCorpusLibListFunc = () => {
        getDocTranslateLib({
          libType: 2,
          sourceLanguageId: state.sourceLangId || 1,
          targetLanguageId: state.targetLangId,
          langReverse: true,
          includeShare: false,
          includeCollect: false,
        }).then((res) => {
          let myList = res.data.data.myLibs || []
          let eList = res.data.data.enterpriseLibs || []
          myList.forEach((item) => {
            item.libType = 1
          })
          eList.forEach((item) => {
            item.libType = 2
          })
          const list = [...myList, ...eList]
          state.corpusData = list
        })
      }

      const updateDefaultTerm = (libraryId) => {
        if (libraryId == -1) {
          state.defaultTerm = {}
          return
        }
        const list = state.termData.filter(
          (item) => item.library_id === libraryId
        )
        state.defaultTerm = list.length > 0 ? list[0] : {}
      }

      const updateDefaultCorpus = (libraryId) => {
        if (libraryId == -1) {
          state.defaultCorpus = {}
          return
        }
        const list = state.corpusData.filter(
          (item) => item.library_id === libraryId
        )
        state.defaultCorpus = list.length > 0 ? list[0] : {}
      }

      //展示语料弹窗
      const showCorpusModal = () => {
        state.corpusVisible = true
      }

      const showTermModal = () => {
        state.termVisible = true
      }

      onBeforeUnmount(() => {
        clearTimeout(refreshTimer)
      })

      onMounted(async () => {
        if (languageRef.value) {
          languageRef.value.srcLanguage = state.sourceLangId
          languageRef.value.tarLanguage = state.targetLangId
        }
        //赋值路由参数
        // if (sessionStorage.getItem("parseMode")) {
        //   state.parseMode = parseInt(sessionStorage.getItem("parseMode"))
        // }
        getAllMtList()
        getDocMtLibListFunc()
        getDocCorpusLibListFunc()
      })

      onUnmounted(() => {
        sessionStorage.removeItem('db_file')
        sessionStorage.removeItem('parseMode')
      })

      watch(
        () => [state.sourceLangId, state.targetLangId],
        (n) => {
          //重置引擎选择
          state.chooseTwinslatorObj = {}
          getDocMtLibListFunc()
          getDocCorpusLibListFunc()
        }
      )

      return {
        calculateTextRef,
        translationListRef,
        updateDefaultCorpus,
        uploadClick,
        ...toRefs(state),
        uploadSize,
        flag,
        loading,
        isPre,
        spinLoading,
        loadingOpacity,
        languageRef,
        // priceRef,
        files,
        enterpriseGlobalId,
        settingDetail,
        customRequest,
        removeFile,
        startFunc,
        confirmOrder,
        changeLanguage,
        chooseMt,
        updateDefaultTerm,
        showTermModal,
        showCorpusModal,
        getAllMtList,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .mt-price {
    font-size: 12px;
    color: #bbb;
    text-align: center;
  }
  .mt-box :deep(.ant-modal-close-x) {
    width: 72px;
    height: 72px;
    line-height: 72px;
  }
  .doc-container {
    .doc-tab {
      background-color: #fff;
      border: 1px solid #f2f3f5;
      border-radius: 8px;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
      .choose-box {
        height: 58px;
        font-size: 14px;
        border-bottom: 1px solid #f2f3f5;
        margin: 0 20px;
      }
      .translate-box {
        height: 360px;
        padding: 20px 88px 0;
        :deep(.ant-upload-drag) {
          height: 320px;
          background: #fff;
          border: 1px solid #f2f3f5;
          border-radius: 16px;
          .ant-upload-hint {
            font-size: 16px;
            color: #999;
          }
          &:hover {
            border: 1px solid #dcd3ff;
          }
        }
      }
      .padding-lr-300 {
        padding: 40px 300px;
      }
      .success-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 320px;
        padding: 40px 0;
        border: 1px solid #dcd3ff;
        border-radius: 16px;
      }

      .term-box {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 56px;
        //padding-left: 20px;
        background: #fafafc;
        border-radius: 0px 0px 16px 16px;
        border: 1px solid #f2f3f5;
        border-bottom: 0;
      }

      .term-corpus-box {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 56px;
        //padding-left: 20px;
        background: #fafafc;
        border-radius: 0px 0px 16px 16px;
        border: 1px solid #f2f3f5;
        border-bottom: 0;
        display: flex;
      }

      .term-box,
      .term-corpus-box {
        .select-box {
          :deep(.ant-select-selector) {
            border-radius: 20px;
            border: 1px solid #edeeef;
            .ant-select-selection-item {
              text-align: left;
            }
          }
          :deep(.ant-select-arrow) {
            margin-top: -4px;
            color: #333;
            font-size: 10px;
          }
        }
      }

      .upload-default-img-box {
        width: 264px;
        height: 66px;
        margin: 0 auto 0;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .btn-box {
        padding-bottom: 10px;
        .trans-btn {
          width: 136px;
          height: 40px;
          padding: 0;
          // opacity: 0.3;
          opacity: 1;
        }
        .loading-opacity {
          opacity: 1;
        }
      }
    }
    .img-box {
      width: 1220px;
      margin: 0 auto 10px;
      margin-left: -10px;
      position: relative;
      cursor: pointer;
      .to-pe {
        position: absolute;
        left: 130px;
        bottom: 41px;
        width: 120px;
        height: 32px;
        background-color: transparent;
        cursor: pointer;
      }
    }
  }
  .file-name {
    .icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    flex-shrink: 0;
  }
  .recommend-res {
    height: 32px;
  }
  .mt-item {
    display: flex;
    align-items: center;
    padding: 4px 14px;
    color: #333;
    font-size: 13px;
    background: #fff;
    border-radius: 6px;
    margin-right: 8px;
    user-select: none;
    border: 1px solid #edeeef;
    &:hover {
      border: 1px solid #ded6ff;
    }
  }
  .mt-item-active {
    background: #f6faff;
    border: 2px solid var(--primary-color);
    &:hover {
      background: #f6faff;
      border: 2px solid var(--primary-color);
    }
  }
  .choose-mt-default-box {
    min-width: 104px;
    height: 47px;
    background: #fff;
    color: #333;
    font-size: 14px;
    border-radius: 6px;
    border: 1px solid #edeeef;
    &:hover {
      border: 1px solid var(--primary-color);
    }
  }
  .choose-mt-box {
    padding: 2px 14px;
    //height: 40px;
    height: 47px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid var(--primary-color);
  }
  .all-mt-box {
    width: 500px;
    height: 340px;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    .mt-tabs {
      height: 48px;
      padding: 0 20px 0 30px;
      border-bottom: 1px solid #f2f3f5;
    }
    .mt-tab {
      color: #000;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
    }
    .mt-tab-active {
      position: relative;
      font-weight: 600;
      &::after {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 2px;
        background: #333;
        content: '';
      }
    }
    .mt-common {
      padding: 20px 0 20px 20px;
      height: calc(100% - 48px);
      overflow-y: auto;
      &::-webkit-input-placeholder {
        font-size: 14px;
        color: #818385;
      }
      &::-webkit-scrollbar {
        width: 7px;
        background-color: rgba(0, 0, 0, 0);
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
        width: 7px;
      }
    }
    .mt-choose-item {
      position: relative;
      //height: 90px;
      width: 74px;
      cursor: pointer;
      &:hover {
        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .mt-icon-box {
      width: 48px;
      height: 48px;
      background: #f5f5f5;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .file-type-box {
    width: 50px;
    height: 50px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .choose-term {
    position: relative;
    width: 150px;
    height: 32px;
    padding-left: 16px;
    padding-right: 30px;
    background: #fff;
    border-radius: 20px;
    border: 1px solid #edeeef;
    margin-right: 12px;
    cursor: pointer;
    .down-icon {
      position: absolute;
      right: 16px;
      bottom: 4px;
      width: 16px;
      height: 16px;
      font-size: 10px;
      color: #333;
    }
  }
  .add-btn {
    height: 56px;
    cursor: pointer;
    svg {
      width: 16px;
      height: 16px;
    }
    span {
      height: 16px;
      line-height: 16px;
    }
  }
  .color-7a59ff {
    color: var(--primary-color);
  }
  .success-box {
    :deep(.ant-progress-text) {
      display: none;
    }
    :deep(.ant-progress-show-info .ant-progress-outer) {
      margin-right: 0;
      padding-right: 0;
    }
  }
  .progress-box {
    width: 200px;
  }
  .badge-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 12px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
</style>
